"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var config_provider_1 = require("./../../config-provider");
var Common_1 = __importDefault(require("./../Common"));
var utils_1 = require("./../utils");
var TreeNode_1 = __importDefault(require("./TreeNode"));
var TreeOrigin = /** @class */ (function (_super) {
    __extends(TreeOrigin, _super);
    function TreeOrigin(props, context) {
        var _this = _super.call(this, props) || this;
        _this.onCollapse = function (key) {
            if (_this.keyToNodeMap) {
                var data = _this.keyToNodeMap[String(key)];
                if (data) {
                    if (!data.children) {
                        data.loading = true;
                        _this.setState({ data: _this.state.data });
                    }
                    else {
                        data.collapsed = !data.collapsed;
                        _this.setState({ data: _this.state.data });
                    }
                }
            }
        };
        /**
         * 清空操作
         */
        _this.clear = function () {
            var _a, _b;
            _this.setState({
                mainKeys: [],
                initial: true,
                initialFinally: false,
            });
            (0, utils_1.checkChildren)(_this.state.data.children, false);
            (0, utils_1.checkParent)(_this.state.data.parent, false);
            (_b = (_a = _this.props).onCallback) === null || _b === void 0 ? void 0 : _b.call(_a, []);
        };
        /**
         * 选中key
         * @param key
         */
        _this.onCheck = function (key) {
            var _a, _b, _c;
            (0, utils_1.onCheck)(_this.keyToNodeMap, key);
            _this.setState({ data: _this.state.data, initial: false });
            (_b = (_a = _this.props).onCallback) === null || _b === void 0 ? void 0 : _b.call(_a, (_c = (0, utils_1.filter)(_this.state.data)) === null || _c === void 0 ? void 0 : _c.result);
        };
        _this.setChange = function () {
            var _a, _b, _c, _d;
            _this.setState({
                fix: !_this.state.fix,
            });
            (_b = (_a = _this.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a, _this.state.fix);
            (_d = (_c = _this.props).onCallback) === null || _d === void 0 ? void 0 : _d.call(_c, []);
        };
        /**
         * 弹窗面板
         * @param onConfirmText
         * @param onCancelText
         * @param resultLen
         * @param result
         */
        _this.renderPage = function (resultLen, result, onConfirmText, onCancelText) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(antd_1.Button, { onClick: _this.closePanel }, onCancelText),
                react_1.default.createElement(antd_1.Button, { type: "primary", onClick: function () {
                        var _a, _b, _c, _d;
                        _this.setState({
                            fix: false,
                            initialFinally: !!resultLen,
                            finallyNumber: resultLen,
                        });
                        (_b = (_a = _this.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a, false);
                        (_d = (_c = _this.props).onCallback) === null || _d === void 0 ? void 0 : _d.call(_c, result);
                    } }, onConfirmText)));
        };
        /**
         * 重置
         */
        _this.closePanel = function () {
            var _a, _b;
            (_b = (_a = _this.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a, false);
            _this.clear();
        };
        _this.keyToNodeMap = {};
        _this.context = context;
        var _a = _this.props, data = _a.data, titleText = _a.titleText;
        var mainKeys = [];
        var changeData = (0, utils_1.filterRootData)(data, mainKeys);
        _this.state = {
            initial: true,
            data: changeData,
            fromNode: undefined,
            mainKeys: mainKeys,
            fix: false,
            titleTextState: titleText,
            initialFinally: false,
            finallyNumber: 0,
        };
        return _this;
    }
    TreeOrigin.prototype.componentDidMount = function () {
        var _this = this;
        (0, utils_1.buildKeyMap)(this.state.data, function (data, keyToNodeMap) {
            _this.keyToNodeMap = keyToNodeMap;
            _this.setState({ data: data });
        });
    };
    TreeOrigin.prototype.render = function () {
        var _a = this.props, _b = _a.clearText, clearText = _b === void 0 ? '清空所有选项' : _b, _c = _a.totalText, totalText = _c === void 0 ? 'Total results' : _c, _d = _a.totalSelectedText, totalSelectedText = _d === void 0 ? 'Total selected' : _d, _e = _a.titleText, titleText = _e === void 0 ? 'Refine results' : _e, showText = _a.showText, showLessText = _a.showLessText, style = _a.style, className = _a.className, _f = _a.onConfirmText, onConfirmText = _f === void 0 ? 'confirm' : _f, _g = _a.onCancelText, onCancelText = _g === void 0 ? '重置' : _g;
        var _h = this.context.classPrefix, classPrefix = _h === void 0 ? 'intl' : _h;
        var _j = this.state, fix = _j.fix, data = _j.data, initial = _j.initial, initialFinally = _j.initialFinally, finallyNumber = _j.finallyNumber;
        var getData = (0, utils_1.filter)(this.state.data);
        var showTxt = titleText || '';
        if (!fix && initialFinally) {
            showTxt = "".concat(totalSelectedText, " : ").concat(finallyNumber);
        }
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(classPrefix, "__tree-sizer ").concat(classPrefix, "__tree--common ").concat(classPrefix, "__tree--vertical"), {
                'vertical-modal-mask': fix,
            }, className), onClick: this.closePanel, style: style },
            react_1.default.createElement("div", { className: (0, classnames_1.default)({ 'mo-fixed': fix }), onClick: function (e) { return e.stopPropagation(); } },
                react_1.default.createElement(Common_1.default, { icon: ['right', 'close'], initIconUrl: fix, onCallback: this.setChange, titleText: showTxt, switchHidden: true }),
                react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(classPrefix, "__layout-vertical"), {
                        'layout-vertical--hidden': !fix,
                    }) },
                    react_1.default.createElement("div", { className: "vertical-list" },
                        react_1.default.createElement(TreeNode_1.default, { root: true, onCheck: this.onCheck, onCollapse: this.onCollapse, data: data, showText: showText, showLessText: showLessText })),
                    react_1.default.createElement("p", { className: "tree-dot", onClick: this.clear }, clearText),
                    react_1.default.createElement("div", { className: "tree-plain" },
                        react_1.default.createElement("p", null,
                            initial ? totalText : totalSelectedText,
                            " :\u00A0",
                            initial ? getData === null || getData === void 0 ? void 0 : getData.countNun : getData === null || getData === void 0 ? void 0 : getData.resultLen),
                        react_1.default.createElement("div", { className: "tree-d-flex" }, this.renderPage(getData === null || getData === void 0 ? void 0 : getData.resultLen, getData === null || getData === void 0 ? void 0 : getData.result, onConfirmText, onCancelText)))))));
    };
    return TreeOrigin;
}(react_1.default.Component));
exports.default = TreeOrigin;
TreeOrigin.contextType = config_provider_1.ConfigContext;
//# sourceMappingURL=TreeOrigin.js.map